import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import {
  ApiProperty,
  ApiPropertyOptional,
  IntersectionType,
} from '@nestjs/swagger';
import { ArchivableEntityDto } from '../../common/dto/archivable-entity.dto';
import { SubdivisionBuilderSupervisorInterface } from '../interfaces/subdivision-builder-supervisor.interface';
import { UserDto } from '../../user/dto/user.dto';
import { SubdivisionDto } from '../../subdivision/dto/subdivision.dto';

@Exclude()
export class SubdivisionBuilderSupervisorDto
  extends IntersectionType(CommonEntityDto, ArchivableEntityDto)
  implements SubdivisionBuilderSupervisorInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated subdivision ID',
  })
  @IsUUID()
  @Expose()
  subdivisionId!: string;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'User',
    description: 'The user associated with this subdivision',
  })
  @Expose()
  user?: UserDto;

  @ApiPropertyOptional({
    type: () => [SubdivisionDto],
    title: 'Subdivision',
    description: 'The subdivision associated with this user',
  })
  @Expose()
  subdivision?: SubdivisionDto;
}
